import { datadogRum } from '@datadog/browser-rum';

const version = process.env.PACKAGE_VERSION;
const env = process.env.NODE_ENV || 'develop';
const REMOTE_CONFIGURATION_ID = 'c12bf472-2575-4a8e-a026-daa4d0724d12';

// Taux de replay et suivi (interactions, ressources, tâches longues) :
// réglés dans Datadog, Remote Configuration (cartes #6477 et #6578).
// Ne pas les remettre ici. Taux de sessions : défaut du SDK (100 %).
export const start = () =>
  datadogRum.init({
    applicationId: '5300d302-6ac1-4586-b1c5-98545270c5bd',
    clientToken: 'pub79453bd7b0fde80571d859dc36184029',
    site: 'datadoghq.com',
    remoteConfiguration: {
      id: REMOTE_CONFIGURATION_ID,
    },
    // Envois et configuration distante par notre domaine : les bloqueurs
    // de publicité refusent les domaines Datadog (carte #6635). Les
    // préfixes /obs et /obs-config doivent rester ceux de nginx.conf.
    proxy: ({ path, parameters }) =>
      `${window.location.origin}/obs${path}?${parameters}`,
    remoteConfigurationProxy:
      `${window.location.origin}/obs-config/${REMOTE_CONFIGURATION_ID}.json`,
    env,
    service: 'back-artisan-front',
    version: `v${version || '1.0.0'}`,
    // Masquage écrit en dur, même s'il vaut le défaut : le défaut a
    // changé entre la v6 et la v7 du SDK, une mise à jour ne doit pas
    // le modifier en silence.
    defaultPrivacyLevel: 'mask-user-input',
    enablePrivacyForActionName: true,
    // Relie chaque session RUM aux traces APM des appels vers notre back.
    allowedTracingUrls: [
      {
        match: window.location.origin,
        propagatorTypes: ['datadog', 'tracecontext'],
      },
    ],
  });

export const addUserSession = (user) => {
  datadogRum.setUser({
    id: `${user.id}`,
    name: user.companyName || user.login,
    tel1: user.tel1,
    _id: user._id,
  });
  datadogRum.startSessionReplayRecording();
};

export const stopSessionReplayRecording = () =>
  datadogRum.stopSessionReplayRecording();
